import useTranslations from '../../../hooks/useTranslations'
import HightChart from '../../charts'

const DonutRaceChart = ({ dataSeries, title }) => {
  const { t } = useTranslations()
  const options = {
    chart: {
      type: 'pie',
      height: 250,
    },
    title: {
      text: t(title),
      align: 'center',
    },
    credits: false,
    // subtitle: {
    //   useHTML: true,
    //   text: `<span class="d-flex justify-center align-center flex-column">
    //       <span style="font-size: 70px">${/* data?.total */ 77 ?? 0}</span>
    //       <span style="font-size: 18px">
    //         ${t('Total Input')}
    //       </span>
    //     </span>`,
    //   floating: true,
    //   verticalAlign: 'middle',
    //   y: 20,
    // },

    legend: {
      enabled: false,
    },

    tooltip: {
      valueDecimals: 0,
      valueSuffix: '%',
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        colorByPoint: true,
        type: 'pie',
        size: '100%',
        innerSize: '80%',
        dataLabels: {
          enabled: true,
          crop: false,
          distance: '-10%',
          style: {
            fontWeight: 'bold',
            fontSize: '16px',
          },
          connectorWidth: 0,
        },
      },
    },
    colors: ['#2d7b06', '#9f9d9d', '#13dcfb', '#f7a35c'],
    series: [
      {
        type: 'pie',
        name: title,
        data: dataSeries,
      },
    ],
  }
  return (
    <>
      <HightChart options={options} />
      {/* {!data.loader ? (
      ) : (
        <NoDataLoaderCard
          title={t('dash_TotalJobsOpenVSCompleted')}
          loading={data.loader}
        />
      )} */}
    </>
  )
}

export default DonutRaceChart
